import { ReportTourDetailOtherExpenseModel } from 'api-hooks/report';
import { PaginationMeta } from 'common/repositories/common.model';
import QueryFilter from 'components/common/query-filter/query-filter';
import Separator from 'components/common/separator';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { TableContainer } from 'components/styles';
import { FilterHandleParentProvider } from 'hooks/filter/use-filter-handle-parent';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  data?: ReportTourDetailOtherExpenseModel[];
  isLoading: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  columns: IColumn<any>[];
  filters: any;
  setFilters: any;
}

export default function TourDetailOtherExpenseCard(props: Props) {
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    page,
    onPageChange,
    meta,
    columns,
    filters,
    setFilters,
  } = props;

  return (
    <FilterHandleParentProvider
      values={{
        filters,
        setFilters,
        page,
        setPage: onPageChange,
      }}
    >
      <Text variant="HeadingXSmall">{t('common:expense_details')}</Text>
      <Separator gap={8} direction="vertical">
        <QueryFilter {...{ setFilters, setPage: onPageChange, filters }} />
      </Separator>
      <Separator gap={8} />
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={isLoading}
          data={data || []}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </FilterHandleParentProvider>
  );
}
